<template>
  <!-- Upload content -->
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9">
            <v-btn class="mr-2" to="/admin/keywords/add" v-if="listView">Add</v-btn>
            <v-btn class="mr-2" to="/admin/keywords" v-else >Close</v-btn>
        </v-col>
      </v-row>
    </v-col>
   <v-col :cols="containerWidth">
        <h3 class="mb-4">Keywords</h3>
        <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.title }}</td>
                  <td>
                    <v-chip class="mr-2" :to="`/admin/keywords/show/${item.id}`">
                      Show
                    </v-chip>
                    <v-chip class="mr-2" :to="`/admin/keywords/edit/${item.id}`">
                      Edit
                    </v-chip>
                    <v-chip class="mr-2" @click="deleteItem(item.id)">
                      Delete
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
    </v-col>
     <v-col cols="4">
      <router-view></router-view>
    </v-col>
  </v-row>
  
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import router from "@/router";

export default {
  name: "AdminKeywordsList",
  data() {
    return {
      collection: fb.keywordsCollection,
      items: null,
      returnRoute: 'AdminKeywordsList'
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    listView() {
      return this.$route.name == "AdminKeywordsList" ? true : false;
    },
    containerWidth() {
      return this.listView ? "12" : "8";
    },
    cardWidth() {
      return this.listView ? "3" : "4";
    },
  },
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      console.log('get items')
      this.collection
        .orderBy("createdOn", "desc")
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    deleteItem(id) {
      this.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    }
  },
};
</script>
